<template>
    <div style="width: 100%;height:100%;">
      <img style="position: absolute " :src="require('../../assets/user_system/login_bg_img.jpeg')" width="100%" height="100%" alt="" />
      <v-layout row style="position: absolute;height:50px;left: 30px;top: 4px" class="ma-0">
        <v-img src="../../assets/top_bar/logoAndTitleNew.png" style="width:220px;flex:none;margin-right:14px;"></v-img>
      </v-layout>
      <div style="width: 400px;height: 525px;position: absolute;left: 50%;top: 50%;transform: translate(-50%,-50%)">
        <div style="width: 100%;height: 75px;">
          <v-img contain src="../../assets/user_system/login_header_logo.jpg" width="95" height="61" style="float: left"></v-img>
          <v-img contain src="../../assets/user_system/login_header_title.jpg" width="95" height="31" style="float: left;margin-top: 24px;margin-left: -5px"></v-img>
          <div style="line-height: 75px;font-size: 20px;color:black;letter-spacing: 2px;font-weight: 600">&nbsp;&nbsp;/&nbsp;&nbsp;让遥感走进生活</div>
        </div>
        <!--扫码绑定或登录card-->
        <v-card v-show="currentCard === 'bindOrLoginCard'" class="card">
          <div style="height: 24px;">
            <div style="color:rgba(0, 0, 0, 1);font-size: 24px;float: left;line-height: 24px;font-weight: 400;">欢迎使用</div>
            <div @click="changeLoginWay" style="cursor: pointer;color:rgba(25, 118, 210, 1);font-size: 16px;float: right;line-height: 24px">{{loginWay === "qrCode"?"账号密码登录":"返回扫码登录"}}</div>
          </div>
          <!--内容-->
          <!--二维码登录-->
          <div v-show ="loginWay === 'qrCode'">
            <div style="width: 180px;height: 180px;margin: 67px auto 35px auto;">
              <!--二维码-->
              <div ref="qrCode" style="width: 180px;height: 180px;position: absolute;"></div>
              <!--扫码成功蒙层-->
              <div v-show="scanSuccess" style="position: absolute;width: 180px;height: 180px;background-color: rgba(255, 255, 255, 0.95);display: flex;align-items: center;justify-content: center;">
                <div style="width: max-content;height: 40px">
                  <span class="iconfontFamily" style="font-size: 40px;color: rgba(67, 207, 124, 1);float: left;line-height: 40px">&#xe602;</span>     <div style="font-size: 20px;color: rgba(67, 207, 124, 1);line-height: 40px;float: left;margin-left: 5px">扫码成功</div>
                </div>
              </div>
              <!--二维码失效蒙层-->
              <div v-show="qrCodeExpired" style="position: absolute;width: 180px;height: 180px;background-color: rgba(255, 255, 255, 0.95);display: flex;align-items: center;justify-content: center;">
                <div style="width: max-content;height: 40px">
                  <div style="font-size: 16px;line-height: 40px;margin-left: 5px">二维码已过期</div>
                  <div @click="generateQRCode" style="font-size: 16px;line-height: 40px;margin: 0 auto;width: max-content;color: rgba(25, 118, 210, 1);cursor: pointer">点击刷新</div>
                </div>
              </div>

            </div>
            <div style="color:rgba(166, 166, 166, 1);font-size: 14px;margin: 0 auto;width: fit-content">{{qrHintText}}</div>
            <div style="color:rgba(166, 166, 166, 1);font-size: 14px;margin: 90px auto 0 auto;width: max-content">登录即同意《<span @click="gotoPrivacyAndAgreement('userAgreement')" style="cursor: pointer;color: rgba(25, 118, 210, 1)">服务协议</span>》和《<span @click="gotoPrivacyAndAgreement('privacy')" style="cursor: pointer;color: rgba(25, 118, 210, 1)">隐私条款</span>》</div>
          </div>
          <!--密码登录-->
          <div v-show ="loginWay === 'account'" style="width: 270px;margin: 0 auto">
            <!--邮箱-->
            <v-form class="pt-15"
                    ref="loginForm"
                    v-model="isLoginMsgValid">
              <v-text-field
                  placeholder="请输入邮箱账号"
                  v-model="loginAccount"
                  :rules = "emailRules"
                  required>
                <template v-slot:message>
                  <div style="padding-top: 1px;padding-right: 1px" ><span class="iconfontFamily" style="font-size: 12px;color: rgba(255, 0, 0, 1)">&#xe612;</span>&nbsp;请输入正确的邮箱格式</div>
                </template>
              </v-text-field>
              <v-text-field
                  placeholder="请输入密码"
                  v-model="loginPassword"
                  :append-icon="showLoginPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showLoginPassword ? 'text' : 'password'"
                  class="input-group--focused"
                  :rules="requiredRule"
                  @click:append="showLoginPassword = !showLoginPassword">
                    <template  v-slot:message style="margin-top: -16px;color: rgba(255, 0, 0, 0.75);font-size: 12px" ><span class="iconfontFamily">&#xe612;</span>&nbsp;密码不能为空</template>
              </v-text-field>
            </v-form>
            <div v-show="loginVerifyCodeError" style="margin-top: -18px;color: rgba(255, 0, 0, 0.75);font-size: 12px" ><span class="iconfontFamily">&#xe612;</span>&nbsp;你输入的账号或密码不正确，请重新输入</div>
            <div style="color:rgba(166, 166, 166, 1);font-size: 14px;margin-top: 17px;width: max-content">登录即同意《<span @click="gotoPrivacyAndAgreement('userAgreement')" style="cursor: pointer;color: rgba(25, 118, 210, 1)">服务协议</span>》和《<span @click="gotoPrivacyAndAgreement('privacy')" style="cursor: pointer;color: rgba(25, 118, 210, 1)">隐私条款</span>》</div>
            <v-btn
                @click="loginEvent"
                width="280px"
                height="40px"
                depressed
                :color="loginBtnClickable?'rgba(25, 118, 210, 1)':'rgba(140, 187, 233, 1)'"
                style="margin-top: 30px;color: white;font-size: 16px">
              登录</v-btn>
            <div style="height: 16px;margin-top: 22px">
              <div @click="goToRegister" style="cursor: pointer;color:rgba(25, 118, 210, 1);font-size: 16px;float: left;line-height: 16px;font-weight: 400;">立即注册</div>
              <div @click="gotoRetrievePassword" style="cursor: pointer;color:rgba(25, 118, 210, 1);font-size: 16px;float: right;line-height: 16px">忘记密码</div>
            </div>
          </div>
        </v-card>
        <Vcode :show="showPicVerify" @success="onPicVerifySuccess" @close="closePicVerify" successText="验证成功！"
               failText="验证失败，请重试！"/>
        <!--完善登录信息或注册card-->
        <v-card v-show="currentCard === 'registerOrPerfectCard'" class="registerCard">
          <div style="height: 24px;">
            <div style="color:rgba(0, 0, 0, 1);font-size: 20px;float: left;line-height: 20px;font-weight: 400;">{{registerWay === 'perfect'?"完善登录信息":"用户注册"}}</div>
            <div v-show="registerWay === 'register'" @click="backToAccountLogin" style="cursor: pointer;color:rgba(25, 118, 210, 1);font-size: 16px;float: right;line-height: 24px">返回登录</div>
          </div>
          <div style="width: 280px;margin: 0 auto">
           <v-form class="pt-6"
                   ref="registerForm"
                   v-model="isRegisterMsgValid">
             <v-text-field
                 placeholder="请输入电子邮箱"
                 autocomplete="off"
                 v-model="registerEmail"
                  :rules = "emailRules"
                 @focus="registerMailBlur"
                 required>
                   <template v-slot:message>
                     <div  style="padding-top: 1px;padding-right: 1px" ><span class="iconfontFamily" style="font-size: 12px;color: rgba(255, 0, 0, 1)">&#xe612;</span>&nbsp;请输入正确的邮箱格式</div>
                   </template>
             </v-text-field>
             <div>
               <div v-show="registerMailOccupied" style="margin-top: -16px;color: rgba(255, 0, 0, 0.75);font-size: 12px" ><span class="iconfontFamily">&#xe612;</span>&nbsp;该邮箱已注册</div>
             </div>
             <v-text-field
                 placeholder="请设置创作平台密码"
                 autocomplete="off"
                 v-model="registerPassword"
                 :rules="passwordRules"
                 :append-icon="showRegisterPassword ? 'mdi-eye' : 'mdi-eye-off'"
                 :type="showRegisterPassword ? 'text' : 'password'"
                 class="input-group--focused"
                 @click:append="showRegisterPassword = !showRegisterPassword">
                   <template v-slot:message>
                     <div style="padding-top: 1px;padding-right: 1px" ><span class="iconfontFamily" style="font-size: 12px;color: rgba(255, 0, 0, 1)">&#xe612;</span>&nbsp;密码为6-16个字符，且包含数字和字母及特殊字符</div>
                   </template>
             </v-text-field>
             <v-text-field
                 placeholder="请重新输入密码"
                 autocomplete="off"
                 v-model="registerPassword2"
                 :rules="password2Rules"
                 :append-icon="showRegisterPassword2 ? 'mdi-eye' : 'mdi-eye-off'"
                 :type="showRegisterPassword2 ? 'text' : 'password'"
                 class="input-group--focused"
                 @click:append="showRegisterPassword2 = !showRegisterPassword2">
                   <template v-slot:message>
                     <div style="padding-top: 1px;padding-right: 1px" ><span class="iconfontFamily" style="font-size: 12px;color: rgba(255, 0, 0, 1)">&#xe612;</span>&nbsp;两次密码不一致</div>
                   </template>
             </v-text-field>
             <div style="position: relative">
               <v-text-field
                   placeholder="请输入邮箱验证码"
                   autocomplete="off"
                   v-model="registerVerifyCode"
                   class="input-group--focused"
                    border="none">
                 <template v-slot:append>
                   <div  @click="sendVerifyCode" style="width: max-content;cursor: pointer;line-height: 30px" :style="{color:sendingAvailable?'rgba(25, 118, 210, 1)':'rgba(166, 166, 166, 1)'}">{{sendCodeContent}}</div>
                 </template>
               </v-text-field>
               <div>
                 <div v-show="registerVerifyCodeError" style="margin-top: -16px;color: rgba(255, 0, 0, 0.75);font-size: 12px" ><span class="iconfontFamily">&#xe612;</span>&nbsp;验证码有误</div>
               </div>
             </div>
           </v-form>
            <!--隐私协议-->
            <v-layout row class="ma-0" style="height: 20px;">
              <v-checkbox
                class="mt-0 mr-2"
                style="zoom: 70%;width: 20px;height: 20px;margin-right: 8px"
                v-model="privacyCheckbox">
              </v-checkbox>
              <div style="color:rgba(166, 166, 166, 1);font-size: 13px;line-height: 22px">我已阅读并同意《<span @click="gotoPrivacyAndAgreement('userAgreement')" style="cursor: pointer;color: rgba(25, 118, 210, 1)">服务协议</span>》和《<span @click="gotoPrivacyAndAgreement('privacy')" style="cursor: pointer;color: rgba(25, 118, 210, 1)">隐私条款</span>》</div>
            </v-layout>
            <v-btn
                @click="registerEvent"
                width="280px"
                height="40px"
                depressed
                :color="registerBtnClickable?'rgba(25, 118, 210, 1)':'rgba(140, 187, 233, 1)'"
                style="position:absolute;bottom: 73px;color: white;font-size: 16px">
              {{registerWay ==='perfect'?'登录':'注册并登录'}}</v-btn>
          </div>
        </v-card>
      </div>

    </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import Vcode from "vue-puzzle-vcode";
import utils from "@/utils/utils";
export default {
  name: "Login",
  components: {
    Vcode,
  },
  data(){
    return {
      currentCard:"bindOrLoginCard",
      // currentCard:"registerOrPerfectCard",
      loginWay:"qrCode",
      // loginWay:"account",
      registerWay:"perfect",
      // registerWay:"register",
      qrHintText:'请使用共生地球APP扫码登录/注册',
      loginAccount:"",
      loginPassword:"",
      showLoginPassword:false,
      showPicCount:0,
      showPicVerify: false,
      picVerifySuccess:false,
      scanSuccess:false,
      //绑定扫码成功后前端轮询接口里返回的token
      appToken:'',
      registerEmail:"",
      registerMailOccupied:false,
      registerPassword:"",
      registerPassword2:"",
      showRegisterPassword:false,
      showRegisterPassword2:false,
      registerVerifyCode:"",
      ///验证码倒计时
      sendingAvailable:true,
      countDownNum:60,
      sendCodeContent:'获取验证码',

      privacyCheckbox:false,
      isLoginMsgValid:true,
      isRegisterMsgValid:true,
      loginVerifyCodeError:false,
      registerVerifyCodeError:false,
      queryTimer:null,
      isValidTimer:null,
      qrCodeExpired:false,
      loginSuccessToast:true,

      requiredRule:[
        v => !!v || 'E-mail is required',
      ],
      emailRules: [
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      passwordRules:utils.passwordRules,
      password2Rules:[
        v => !!v || 'Name is required',
        v => (v && v === this.registerPassword ) || "1"
      ],
    }
  },
  computed:{
    loginBtnClickable(){
      return /.+@.+\..+/.test(this.loginAccount)&&this.loginPassword.length>0
    },
    registerBtnClickable(){
      // if(this.registerWay === 'perfect'){
      //   return /.+@.+\..+/.test(this.registerEmail) && this.registerPassword.length >= 6 && this.registerPassword.length <= 16 && this.registerPassword === this.registerPassword2 && this.registerVerifyCode.length>0
      // }else {
        return /.+@.+\..+/.test(this.registerEmail) && this.registerPassword.length >= 6 && this.registerPassword.length <= 16 && this.registerPassword === this.registerPassword2 && this.registerVerifyCode.length>0 && this.privacyCheckbox === true
      // }
    }
  },
  watch:{
    loginPassword(){
      if(this.loginPassword === ''){
        this.loginVerifyCodeError = false
      }
    }
  },
  mounted() {
    if(this.$route.query.currentCard !== undefined){
      this.currentCard = this.$route.query.currentCard
      this.loginWay = this.$route.query.way
    }
    this.qrHintText = "请使用共生地球APP扫码登录/注册";
    this.generateQRCode()
  },
  methods: {
    registerMailBlur(){
      this.registerMailOccupied = false
    },
    async generateQRCode(){
      // 初始化timer
      this.qrCodeExpired = false
      if(this.queryTimer){
        clearInterval(this.queryTimer)
        this.queryTimer = null
      }
      if(this.isValidTimer){
        clearTimeout(this.isValidTimer)
        this.isValidTimer = null
      }

      // 拉取二维码字符串
      let resultData = await this.$axios.get('/userApi/creator/getQRCode',{
            params:{'purpose':'loginOrRegister'}
          })
      let code = {
        'type':'CodeScanType.loginAuthor',
        'content':resultData.data.data
      }
      if(resultData.data.code === 200){
        //清除二维码方法一
        this.$refs.qrCode.innerHTML = '';
        new QRCode(this.$refs.qrCode, {
          //二维码内容
          text: JSON.stringify(code),
          width: 180,
          height: 180,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H,
        });
      }
      if(resultData.data.code === 200){
        // 轮询APP扫码状态
        this.queryTimer = setInterval(() => {
          this.$axios.get('/userApi/creator/checkQRCodeStatus',{
            params:{
              'QRCode':resultData.data.data
            }
          }).then(
              (resultData)=>{
                if(resultData.data.data.status === 1){
                  this.scanSuccess = true
                  this.qrHintText = '请在共生地球APP中进行确认'
                  clearTimeout(this.isValidTimer)
                }else if(resultData.data.data.status === 2){
                  this.appToken = resultData.data.data.appToken
                  // 注册绑定
                  this.currentCard = "registerOrPerfectCard"
                  this.privacyCheckbox = false
                  this.registerWay = "perfect"
                  clearTimeout(this.isValidTimer)
                  clearInterval(this.queryTimer)
                  this.initQRCodeStatus()
                }else if(resultData.data.data.status === 3){
                  // 直接登录（返回数据已包含登录信息）
                  window.localStorage.setItem('authorToken',resultData.data.token)
                  clearTimeout(this.isValidTimer)
                  clearInterval(this.queryTimer)
                  this.getUserInfo()
                  this.initQRCodeStatus()
                  // this.$router.push({
                  //   path: '/globe',
                  // })
                }
              })
        },1000);
        // 设置5分钟后二维码失效
        this.isValidTimer = window.setInterval(() => {
          clearTimeout(this.isValidTimer)
          clearInterval(this.queryTimer)
          this.isValidTimer = null
          this.qrCodeExpired = true
        }, 60*5*1000)
      }
    },
    initQRCodeStatus(){
      this.qrHintText = "请使用共生地球APP扫码登录/注册";
      this.generateQRCode()
      this.scanSuccess = false
    },
    changeLoginWay(){
      if(this.loginWay ===  "qrCode"){
        clearTimeout(this.isValidTimer)
        clearInterval(this.queryTimer)
        this.loginWay = "account"
      }else{
        this.loginWay = "qrCode"
        this.generateQRCode()
      }
    },
    async loginEvent(){
      // this.getUserInfo()
      this.loginVerifyCodeError = false
      // this.loginVerifyCodeError = true
      // this.showPicVerify = true
      let formValidate = this.validateLoginForm ()
      if(formValidate){
        if(this.showPicCount >= 3 && !this.picVerifySuccess){
          this.showPicVerify = true
          return
        }
        let resultData = await this.$axios.get('/userApi/creator/loginCreator',{
          params:{
            "email":this.loginAccount,
            "password":this.loginPassword
          }
        })
          if(resultData.data.code !== 200){
            this.loginVerifyCodeError = true
            this.showPicCount = this.showPicCount + 1
            this.picVerifySuccess = false
          }else{
            window.localStorage.setItem('authorToken',resultData.data.token)
            this.getUserInfo()
          }
      }
    },
    getUserInfo(){
      this.$store.state.snackbarShow=true
      this.$store.state.snackbarText = "登录成功"
      this.$store.state.snackbarType = 'success'

      let _this = this
      setTimeout(function(){
        if(_this.$route.query.goBack === 'true' ){
          _this.$router.back()
        }else{
          _this.$router.push({
            path: '/globe',
          })
        }
      },1000)

    },
    registerEvent(){
      if(!this.registerBtnClickable){
        return;
      }
      if(this.showPicCount >= 3 && !this.picVerifySuccess){
        this.showPicVerify = true
        return
      }
      this.registerVerifyCodeError = false
      this.registerMailOccupied = false
      let formData = new FormData();
      formData.append('email',this.registerEmail);
      formData.append('password',this.registerPassword);
      formData.append('captcha',this.registerVerifyCode);
      formData.append('appToken',this.appToken);
      this.$axios.post('/authorApi/personal-data/addPersonalData',formData)
          .then((resultData)=>{
            if(resultData.data.status === 200){
              //新注册用户，清除首次进入状态
              window.localStorage.removeItem('authorFirstOpen')

              window.localStorage.setItem('authorToken',resultData.data.data.token)
              this.getUserInfo()

            }else if(resultData.data.status === 4009){
              this.registerMailOccupied = true
            }else{
              this.registerVerifyCodeError = true
              this.showPicCount = this.showPicCount + 1
              this.picVerifySuccess = false
            }
          })
    },
    // 用户通过了验证
    onPicVerifySuccess(msg) {
      this.showPicVerify = false;
      this.showPicCount = 2
      this.picVerifySuccess = true
      // 通过验证后，需要手动隐藏模态框
    },
    // 用户点击遮罩层，应该关闭模态框
    closePicVerify() {
      this.showPicVerify = false;
    },
    backToAccountLogin(){
      this.currentCard = "bindOrLoginCard"
      this.loginWay = "account"
    },
    sendVerifyCode(){
      if(!this.sendingAvailable){
        return
      }

      let formValidate = this.validateRegisterForm ()
      if(!formValidate){
        return
      }
      this.sendEmail()
    },
    sendEmail(){
      if(!this.sendingAvailable){
        return
      }
      let formData = new FormData()
      formData.append('email',this.registerEmail)
      formData.append( 'purpose','loginOrRegister')
      this.sendingAvailable = false
      this.$axios.post('/userApi/creator/sendEmailCode',formData)
      let clock = window.setInterval(() => {
        this.countDownNum--;
        this.sendCodeContent = "重新发送（"+this.countDownNum+')'
        if (this.countDownNum < 0) {
          //当倒计时小于0时清除定时器
          window.clearInterval(clock); //关闭
          this.sendingAvailable = true;
          this.countDownNum = 60;
          this.sendCodeContent = "获取验证码"
        }
      }, 1000);
    },
    validateRegisterForm () {
      return  this.$refs.registerForm.validate()
    },
    validateLoginForm () {
      return  this.$refs.loginForm.validate()
    },
    goToRegister(){
      this.currentCard = "registerOrPerfectCard"
      this.registerWay = "register"
      this.privacyCheckbox = false
    },
    gotoRetrievePassword(){
      this.$router.push({
        name: 'retrievePassword',
      })
    },
    gotoPrivacyAndAgreement(type){
     let path = this.$router.resolve({
       path: '/documentPage',query:{
          pageType:type
        }
      })
      window.open(path.href,'_blank')
    },
  }
}
</script>

<style scoped>

  .card{
    padding:60px 60px 10px 60px;
    width: 100%;
    height: 100%
  }
  .registerCard{
    padding:40px 60px 10px 60px;
    width: 100%;
    height: 100%
  }
  /*各浏览器提示文本样式*/
  input::-webkit-input-placeholder { /* WebKit browsers */
    color: rgba(166, 166, 166, 1);
    font-size: 16px;
    line-height: 22px;
  }
  input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: rgba(166, 166, 166, 1);
    font-size: 16px;
    line-height: 22px;  }
  input::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: rgba(166, 166, 166, 1);
    font-size: 16px;
    line-height: 22px;  }
  input:-ms-input-placeholder { /* Internet Explorer 10+ */
    color: rgba(166, 166, 166, 1);
    font-size: 16px;
    line-height: 22px;  }
  .bottom_border{
    width: 280px;
    height: 1px;
    background-color: rgba(229, 229, 229, 1);
  }
</style>
